<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="6">
            <v-card-title>
              <v-icon class="mr-2">mdi-pump</v-icon>
              Create Head Pump Size
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      dense
                      solo
                      v-model="form.category"
                      :items="pumpCategoriesFormatted"
                      item-text="text"
                      item-value="value"
                      label="Select Category"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      dense
                      solo
                      v-model="form.power"
                      :items="motorHPOptionsFormatted"
                      item-text="text"
                      item-value="value"
                      label="Select Power"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="form.size"
                      type="number"
                      label="Size"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="form.lpd"
                      type="number"
                      label="LPD"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" text @click="$router.go(-1)">
                Cancel
              </v-btn>
              <v-btn
                color="#6c5dd4"
                dark
                :loading="isLoading"
                :disabled="isLoading"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "HeadPumpSizeCreate",
  data() {
    return {
      valid: false,
      isLoading: false,
      form: {
        category: "",
        power: "",
        size: null,
        lpd: null,
      },
      pumpCategories: [],
      pumpCategoriesFormatted: [],
      motorHPOptions: [],
      motorHPOptionsFormatted: [],
    };
  },
  mounted() {
    this.getPumpCategories();
    this.getMotorHPOptions();
  },
  methods: {
    async save() {
      if (!this.form.category || !this.form.power) {
        this.$vs.notification({
          title: "Validation Error",
          text: "Category and Power are required fields",
          color: "danger",
        });
        return;
      }
      
      try {
        this.isLoading = true;
        await axios.post("/head_pump_sizes", this.form);
        this.isLoading = false;
        this.$vs.notification({
          title: "Success",
          text: "Head Pump Size created successfully",
          color: "success",
        });
        this.$router.push({ name: "HeadPumpSizesPage" });
      } catch (e) {
        this.isLoading = false;
        this.$vs.notification({
          title: "Error",
          text: "Failed to create Head Pump Size",
          color: "danger",
        });
        console.error(e);
      }
    },
    async getPumpCategories() {
      try {
        let response = await axios.get(`/head_pump_sizes/pump_categories`);
        this.pumpCategories = response.data.data;
        
        // Format for v-autocomplete
        this.pumpCategoriesFormatted = [];
        this.pumpCategories.forEach((category) => {
          this.pumpCategoriesFormatted.push({
            id: category.id,
            text: category.description,
            value: category.description,
          });
        });
      } catch (e) {
        console.error('Error fetching pump categories:', e);
        this.$vs.notification({
          title: "Error",
          text: "Failed to load pump categories",
          color: "danger",
        });
      }
    },
    async getMotorHPOptions() {
      try {
        let response = await axios.get(`/head_pump_sizes/motor_hp`);
        this.motorHPOptions = response.data.data;
        
        // Format for v-autocomplete
        this.motorHPOptionsFormatted = [];
        this.motorHPOptions.forEach((power) => {
          this.motorHPOptionsFormatted.push({
            id: power.id,
            text: power.description,
            value: power.description,
          });
        });
      } catch (e) {
        console.error('Error fetching motor HP options:', e);
        this.$vs.notification({
          title: "Error",
          text: "Failed to load motor HP options",
          color: "danger",
        });
      }
    },
  },
};
</script>

<style scoped>
.role-autocomplete .v-input__slot {
  box-shadow: none !important;
  background: #f4f7f8 !important;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
  border-radius: 10px;
}
</style>